import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initTestimonialCarousel() {
    const carousels = document.querySelectorAll('.cmp-testimonial');
  
    carousels.forEach(container => {
      const swiperEl = container.querySelector('.swiper') || container;
      const paginationEl = container.querySelector('.swiper-pagination');
      const nextBtn = container.querySelector('.swiper-button-next');
      const prevBtn = container.querySelector('.swiper-button-prev');
  
      new Swiper(swiperEl, {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 10,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });
    });
  }
  